import React, {useRef, useEffect}       from 'react';
import DayPickerInput                   from 'react-day-picker/DayPickerInput'
import PreviousBtn                      from 'assets/icons/Previous.svg';
import NextBtn                          from 'assets/icons/Next.svg';
import CalendarIcon                     from 'assets/icons/Calendar 2.svg';
import moment                           from 'moment';
import { parseDate }                    from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

export function ReferralFilters({getLogs, meta, page, startDate, endDate, setStartDate, setEndDate}) {
  const formatDate = (date) => {
    return moment(date).format('DD-MM-YYYY');
  }
  const isClosed = useRef(false);

  useEffect(() => {
    getLogs(1);
    return () => {
      isClosed.current = true;
    };
  }, [startDate, endDate]); // eslint-disable-line

  const handlePageChange = (ind) => {
    let newPage = page+(ind);
    if(newPage > 0 && newPage <= meta.total_pages){
      getLogs(newPage);
    }
  }

  const handleStartDayChange = (e) => {
    setStartDate(formatDate(e))
  }
 
  const handleEndDayChange = (e) => {
    setEndDate(formatDate(e))
  }

  return (
    <div className="d-flex justify-content-between align-items-end my-6">
      <div className="d-sm-flex align-items-end">
        <div>
          <p className="mb-1 text-lightgrey font-size-4">From</p>

          <span className="daypicker-container">
            <img src={ CalendarIcon } alt="calendar-icon" className="calendar-icon" />

            <DayPickerInput
              formatDate={ formatDate }
              parseDate={ parseDate }
              format={ 'DD/MM/yyyy' }
              placeholder={ formatDate(new Date()) }
              value={ startDate }
              onDayChange={ handleStartDayChange }
            />
          </span>
        </div>

        <span className="d-none d-sm-inline-block mx-3 font-size-11 fweight-300 mb-2">-</span>

        <div>
          <p className="mb-1 text-lightgrey font-size-4">To</p>

          <span className="daypicker-container">
            <img src={ CalendarIcon } alt="calendar-icon" className="calendar-icon" />

            <DayPickerInput
              formatDate={ formatDate }
              parseDate={ parseDate }
              format={ 'DD/MM/yyyy' }
              placeholder={ formatDate(new Date()) }
              value={ endDate}
              onDayChange={ handleEndDayChange }
            />
          </span>
        </div>
      </div>

      <label className="ml-sm-4 my-2 my-sm-0 mb-0">
        <button className="btn btn-link">
          <img src={ PreviousBtn } alt="previous" className="page-prev-btn" onClick={() => handlePageChange(-1) }/>
        </button>

        <b className="font-size-6 px-2">{page} of {meta.total_pages}</b>

        <button className="btn btn-link">
          <img src={ NextBtn } alt="next" className="page-next-btn" onClick={() => handlePageChange(1) }/>
        </button>
      </label>
    </div>
  )
}

export default ReferralFilters;